export default __webpack_public_path__ + "static/media/inventory-kit.36c3efa9.svg";